import { Controller } from "@hotwired/stimulus"
import StimulusReflex from "stimulus_reflex"

/* This is your ApplicationController.
 * All StimulusReflex controllers should inherit from this class.
 *
 * Example:
 *
 *   import ApplicationController from './application_controller'
 *
 *   export default class extends ApplicationController { ... }
 *
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends Controller {
  connect () {
    StimulusReflex.register(this)
  }

  /* Application-wide lifecycle methods
   *
   * Use these methods to handle lifecycle concerns for the entire application.
   * Using the lifecycle is optional, so feel free to delete these stubs if you don't need them.
   *
   * Arguments:
   *
   *   element - the element that triggered the reflex
   *             may be different than the Stimulus controller's this.element
   *
   *   reflex - the name of the reflex e.g. "Example#demo"
   *
   *   error/noop - the error message (for reflexError), otherwise null
   *
   *   reflexId - a UUID4 or developer-provided unique identifier for each Reflex
   */

  beforeReflex (_element, _reflex, _noop, _reflexId) {
    // document.body.classList.add('wait')
  }

  reflexSuccess (_element, _reflex, _noop, _reflexId) {
    // show success message
  }

  reflexError (_element, _reflex, _error, _reflexId) {
    // show error message
  }

  reflexHalted (_element, _reflex, _error, _reflexId) {
    // handle aborted Reflex action
  }

  afterReflex (_element, _reflex, _noop, _reflexId) {
    // document.body.classList.remove('wait')
  }

  finalizeReflex (_element, _reflex, _noop, _reflexId) {
    // all operations have completed, animation etc is now safe
  }
}
